<!--<app-quick-add-item></app-quick-add-item>-->
<div class="d-super-center flex-xs-column flex-sm-column flex-md-row flex-lg-row flex-xl-row"
     style="color:blue;" *ngIf="shouldShowPaintDisclaimerMsg">
  {{paintDisclaimerMsg}}
</div>
<!-- START DIRECT ITEM ENTRY -->
<div *ngIf="showQuickAdd" class="d-flex flex-column my-3">
  <app-quick-add-item (itemAdded)="itemAdded($event)" [mode]="'add-to-cart'"></app-quick-add-item>
</div>
<!-- END DIRECT ITEM ENTRY -->
<!-- START CART GRID -->
<form novalidate #myForm="ngForm" class="cart-grid-wrapper">
  <ng-template #template let-anchor>
    <span>{{ anchor.nativeElement.innerText }}</span>
  </ng-template>
  <div kendoTooltip
       showOn="none"
       [tooltipTemplate]="template"
       filter=".k-grid td"
       (mouseover)="showTooltip($event)">
    <kendo-grid #grid #cartGrid [data]="cartview"
                [height]=gridHeight
                [pageable]=pageable
                class="cartMainGridCls"
                [pageSize]="gridState.take"
                [skip]="gridState.skip"
                [sortable]="false"
                [navigable]="true"
                [resizable]="true"
                [groupable]="false"
                [rowSelected]="isRowSelected"
                [selectable]="true"
                (pageChange)="cartGridPageChange($event)"
                [loading]="cartLoading">
      <ng-template kendoGridToolbarTemplate>
        <div class="d-flex align-items-center justify-content-between">
          <button kendoButton [icon]="'plus'" class="btn" [selected]="true" (click)="toggleShowQuickAdd()">
            <!-- Quick Add--> {{cartLblTxt.quickAddLbl?cartLblTxt.quickAddLbl:cart.quickAddLbl}}
          </button>
        </div>
        <div class="d-flex align-items-center justify-content-between pwa-btn">
          <button kendoButton [icon]="'plus'" class="btn" (click)="addToQuote()" [disabled]="isEmptyPaintInGrid">
            {{cartLblTxt.addToQuoteLbl?cartLblTxt.addToQuoteLbl:cart.addToQuoteLbl}}<!--Add to Quote-->
          </button>
         
        </div>
        <div class="d-flex align-items-center justify-content-between pwa-btn">
          <button kendoButton [icon]="'trash'" class="btn" (click)="openConfirmRemoveAllDialog()">
            {{cartLblTxt.emptyCartLbl?cartLblTxt.emptyCartLbl:cart.emptyCartLbl}}<!--Empty Cart-->
          </button>
        </div>
      </ng-template>
      <kendo-grid-column media="(max-width: 1024px)" title="Items">
        <ng-template kendoGridCellTemplate let-dataItem>

          <div class="row">
            <div style="width:100%">
              <div class="row">

                <div class="col-5 paddingZero">
                  <div class="row">
                    <div class="col-12 paddingZero">

                      <!-- Image -->
                      <span style="display:none;" *ngIf="!dataItem?.funcCall">{{showImagePWA(dataItem)}}</span>
                      <img class="infoBoxImg a" imageLoader src='../../../assets/images/loading.svg' *ngIf="!dataItem?.thumbnail" [alt]="">
                      <span *ngIf="dataItem?.thumbnail">
                        <img class="cartImage" [src]='dataItem?.thumbnail' alt="{{dataItem.itemNumber}}">
                      </span>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-12 cartItemNumber">
                      {{dataItem.itemNumber}}
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-sm-3 col-md-3 qtyPwa">
                      {{cartLblTxt.quantityLbl?cartLblTxt.quantityLbl:cart.quantityLbl}}:
                      <!-- non-editable qty for non-type-1 -->
                      <span *ngIf="dataItem.itemType!==1">
                        {{dataItem.quantity}}
                      </span>
                    </div>

                    <div class="col-sm-9 col-md-9 paddingZero">
                      <span *ngIf="dataItem?.jobName">
                        {{dataItem?.quantity}}
                      </span>
                      <span *ngIf="!dataItem?.jobName">
                        <app-numeric-text-box [numericData]="dataItem.quantity"
                                              *ngIf="dataItem.itemType===1"
                                              [maxQty]=999
                                              [isUpdateButton]="true"
                                              (event)="change(dataItem,$event)">
                        </app-numeric-text-box>
                      </span>
                    </div>
                  </div>
                </div>

                <div class="col-7 paddingZero">
                  <div class="row">
                    <div class="item-description" [ngClass]="{'col-11':dataItem.itemType===1, 'col-8 col-md-9': dataItem.itemType===2}">
                      {{dataItem.itemDescription}}
                    </div>
                    <div class="paddingZero textRight" [ngClass]="{'col-1':dataItem.itemType===1, 'col-4 col-md-3': dataItem.itemType===2}">
                      <button class="k-button k-grid-edi-command" (click)="navigateToCopyConfigProduct(dataItem)" *ngIf="dataItem.itemType===2">
                        <span class="k-icon k-i-copy"></span>
                      </button>
                      <button class="k-button k-grid-edi-command" (click)="navigateToEditConfigProduct(dataItem)" *ngIf="dataItem.itemType===2">
                        <span class="k-icon k-i-edit"></span>
                      </button>
                      <button class="k-button k-grid-remove-command" (click)="removeConfirmation(dataItem);selectedGridRow(dataItem)">
                        <span class="k-icon k-i-trash"></span>
                      </button>
                    </div>
                  </div>

                  <!-- Finish -->
                  <div class="row">
                    <div class="col-3 paddingZero" style="padding-top:7px; text-align:left">
                      {{cartLblTxt.finishLbl?cartLblTxt.finishLbl:cart.finishLbl}}:
                    </div>
                    <div class="col-9 paddingRightZero">
                      <span *ngIf="dataItem?.jobName">
                        {{dataItem?.finish}}
                      </span>
                      <span *ngIf="!dataItem?.jobName">
                        <kendo-dropdownlist [data]="dataItem.availableFinishes"
                                            (valueChange)="handleCartItemFinishChange($event,dataItem)"
                                            [textField]="'name'"
                                            [valueField]="'value'"
                                            [value]="{value:dataItem.finishValue,name:dataItem.finish}"
                                            class="finishStyleCls"
                                            *ngIf="dataItem.itemType===1 && dataItem.availableFinishes.length>0 && dataItem.availableFinishes[0].value">
                        </kendo-dropdownlist>
                      </span>
                    </div>
                  </div>

                  <!-- Paint -->
                  <div class="row" *ngIf="dataItem.finishValue==='22'">
                    <div class="col-3 paddingZero" style="padding-top:7px; text-align:left">
                      {{cartLblTxt.paintLbl?cartLblTxt.paintLbl:cart.paintLbl}}:
                    </div>
                    <div class="col-9 paddingRightZero">
                      <span *ngIf="dataItem?.jobName">
                        {{dataItem.paintName}}
                      </span>
                      <span *ngIf="!dataItem?.jobName">
                        <kendo-dropdownlist [data]="dataItem.paintValue"
                                            [value]="{value:dataItem.paint,name:dataItem.paintName}"
                                            [textField]="'name'"
                                            [valueField]="'value'"
                                            (valueChange)="handlePaintChange($event,dataItem)"
                                            [filterable]="true"
                                            (filterChange)="handlePaintFilter($event,dataItem)"
                                            (open)="handlePaintFilter(null,dataItem)"
                                            class="finishStyleCls"
                                            [ngClass]="{'borderRed':dataItem?.isEmptyPaint}">
                        </kendo-dropdownlist>
                      </span>
                    </div>
                  </div>

                  <!-- Extrusion -->
                  <div class="row" *ngIf="dataItem.itemType===1">
                    <div class="col-3 paddingZero" style="padding-top:7px; text-align:left">
                      {{cartLblTxt.extrusionLbl?cartLblTxt.extrusionLbl:cart.extrusionLbl}}:
                    </div>
                    <div class="col-9 paddingRightZero">
                      <span *ngIf="dataItem?.jobName">
                        {{dataItem.size}}
                      </span>
                      <span *ngIf="!dataItem?.jobName">
                        <kendo-dropdownlist [data]="dataItem.currentSizes"
                                            [textField]="'value'"
                                            [valueField]="'value'"
                                            [value]="{value:dataItem.size}"
                                            (valueChange)="handleCartItemSizeChange($event,dataItem)"
                                            *ngIf="dataItem?.itemType===1 && dataItem?.currentSizes?.length>0"
                                            class="finishStyleCls">
                        </kendo-dropdownlist>
                        <span *ngIf="dataItem.itemType===1 && dataItem?.currentSizes?.length<1">
                          {{dataItem?.size}}
                        </span>
                      </span>
                    </div>
                  </div>

                  <!-- Unit -->
                  <div class="row">
                    <div class="col-3 paddingZero cartUnit" style="padding-top:7px; text-align:left">
                      {{cartLblTxt.unitLbl?cartLblTxt.unitLbl:cart.unitLbl}}:
                    </div>
                    <div class="col-9 paddingZero cartUnit">
                      EA
                    </div>
                  </div>

                  <!-- Prices Expansion -->
                  <div class="row">
                    <div class="col-12 paddingZero" id="extendedPrice">
                      <kendo-expansionpanel>
                        <ng-template kendoExpansionPanelTitleDirective>
                          <div class="header-content">
                            <span>Price: {{dataItem.extendedPrice | currency: dataItem.currencySymbol}}</span>
                          </div>
                        </ng-template>

                        <div style="font-size:10px;">
                          {{cartLblTxt.listPriceLbl?cartLblTxt.listPriceLbl:cart.listPriceLbl}} -
                          {{dataItem.listPrice | currency: dataItem.currencySymbol}}
                        </div>

                        <div style="font-size:10px;">
                          {{cartLblTxt.unitPriceLbl?cartLblTxt.unitPriceLbl:cart.unitPriceLbl}} -
                          {{dataItem.unitPrice | currency: dataItem.currencySymbol}}
                        </div>

                        <div style="font-size:10px;">
                          {{cartLblTxt.multiplierLbl?cartLblTxt.multiplierLbl:cart.multiplierLbl}} -
                          {{dataItem?.cmp | number:'1.3-3'}}
                        </div>
                      </kendo-expansionpanel>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>

        </ng-template>

        <!-- ===== MOBILE/TABLET FOOTER (replace whole footer template with this) ===== -->
        <ng-template kendoGridFooterTemplate>

          <!-- Total line (single line) -->
          <div class="row">
            <div class="col-4"><span *ngIf="pageable" style="display:none;">{{showPagging(false)}}</span></div>
            <div class="col-8 totalPrice">
              {{cartLblTxt.totalPriceLbl?cartLblTxt.totalPriceLbl:cart.totalPriceLbl}} - {{cartItemsTotal | currency}}
            </div>
          </div>

          <!-- Highest Minimum Order Fee message (one line, red, below Total) -->
          <div class="row" *ngIf="showMinOrderFee">
            <div class="col-12" style="text-align:right;">
              <div class="minfee-line-sm">
                {{ minFeeDisplayLine }}
              </div>
            </div>
          </div>

          <!-- Discount line (unchanged) -->
          <div class="row">
            <div class="col-sm-2 col-md-3"></div>
            <div class="col-sm-7 col-md-5" style="text-align:right;">
              <div class="price-discount-class-sm" *ngIf="gridData.length > 0">
                {{cartLblTxt.cartDiscountLbl?cartLblTxt.cartDiscountLbl:cart.cartDiscountLbl}}
                {{cartDiscount}}%
              </div>
            </div>
            <div class="col-sm-3 col-md-4"></div>
          </div>

          <!-- Gray info list (unchanged) -->
          <div>
            <ul class="messageBoxCustom">
              <li>{{cartLblTxt.gridTextLbl1?cartLblTxt.gridTextLbl1:cart.gridTextLbl1}}</li>
              <li>{{cartLblTxt.gridTextLbl2?cartLblTxt.gridTextLbl2:cart.gridTextLbl2}}</li>
              <li>{{cartLblTxt.gridTextLbl3?cartLblTxt.gridTextLbl3:cart.gridTextLbl3}}</li>
              <li>{{cartLblTxt.gridTextLbl4?cartLblTxt.gridTextLbl4:cart.gridTextLbl4}}</li>
            </ul>
          </div>

        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column media="(min-width: 1050px)" title="{{cartLblTxt.lineLbl?cartLblTxt.lineLbl:cart.lineLbl}}" [width]="60" [resizable]="false" [sortable]="true" [groupable]="false"
                         [editable]="false" [footerStyle]="{'border-color': 'rgba(0,0,0,0)'}">

        <ng-template kendoGridCellTemplate class="d-flex justify-content-center" let-rowIndex="rowIndex">
          <strong>{{rowIndex + 1}}</strong>
          <span *ngIf="!pageable" style="display:none;">{{showPagging(true)}}</span>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column media="(min-width: 1050px)" [filterable]="false" [sortable]="false" field="quantity" title="{{cartLblTxt.quantityLbl?cartLblTxt.quantityLbl:cart.quantityLbl}}"
                         [width]="80" [minResizableWidth]="20">
        <ng-template kendoGridCellTemplate let-dataItem>
          <span *ngIf="dataItem?.jobName">
            {{dataItem.quantity}}
          </span>
          <span *ngIf="!dataItem?.jobName">
            <span *ngIf="dataItem.itemType===1">
              <kendo-numerictextbox [value]="dataItem.quantity" [spinners]="false" [format]="'n'" [decimals]="0" [min]="1"
                                    (valueChange)="handleCartItemQtyChanged($event,dataItem)"
                                    (blur)="handleCartItemQtyUpdate($event,dataItem)" [autoCorrect]="true" class="qtyTxtCls">
              </kendo-numerictextbox>
            </span>
            <span *ngIf="dataItem.itemType!==1">
              {{dataItem.quantity}}
            </span>
          </span>

        </ng-template>
        <ng-template kendoGridFooterTemplate>
          <div>
            <ul class="messageBoxCustom">
              <li>{{cartLblTxt.gridTextLbl1?cartLblTxt.gridTextLbl1:cart.gridTextLbl1}}</li>
              <li>{{cartLblTxt.gridTextLbl2?cartLblTxt.gridTextLbl2:cart.gridTextLbl2}}</li>
              <li>{{cartLblTxt.gridTextLbl3?cartLblTxt.gridTextLbl3:cart.gridTextLbl3}}</li>
              <li>{{cartLblTxt.gridTextLbl4?cartLblTxt.gridTextLbl4:cart.gridTextLbl4}}</li>
            </ul>
          </div>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column media="(min-width: 1050px)" [editable]="false" field="unitOfMeasure" [minResizableWidth]="20" [width]="70" title="{{cartLblTxt.unitLbl?cartLblTxt.unitLbl:cart.unitLbl}}"
                         [footerStyle]="{'border-color': 'rgba(0,0,0,0)'}">

        <ng-template kendoGridCellTemplate let-dataItem>
          EA
          <!--Need to bind dynamically-->
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column media="(min-width: 1050px)" [editable]="false" field="itemNumber" [minResizableWidth]="70" [width]="120" title="{{cartLblTxt.itemLbl?cartLblTxt.itemLbl:cart.itemLbl}}"
                         [footerStyle]="{'border-color': 'rgba(0,0,0,0)'}">
        <ng-template kendoGridCellTemplate let-dataItem>
          <div class="d-flex justify-content-between align-items-center">
            {{dataItem?.itemNumber}}
            <button kendoButton *ngIf="enableEdit" [icon]="'info'" [look]="'flat'" (click)="showImageModal(dataItem,$event)">
            </button>
          </div>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column media="(min-width: 1050px)" field="availableFinish" title="{{cartLblTxt.finishLbl?cartLblTxt.finishLbl:cart.finishLbl}}" [width]="140" [filterable]="false"
                         [sortable]="false">
        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
          <span *ngIf="dataItem?.jobName">
            {{dataItem.finish}}
          </span>
            <span *ngIf="!dataItem?.jobName">
              <kendo-dropdownlist [data]="dataItem.availableFinishes"
                                  (valueChange)="handleCartItemFinishChange($event,dataItem)" [textField]="'name'"
                                  [valueField]="'value'"
                                  [value]="{value:dataItem.finishValue,name:dataItem.finish}" class="finishCls"
                                  *ngIf="dataItem.itemType===1 && dataItem.availableFinishes.length>0 && dataItem.availableFinishes[0].value">
              </kendo-dropdownlist>
            </span>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column media="(min-width: 1050px)" field="paint" title="{{cartLblTxt.paintLbl?cartLblTxt.paintLbl:cart.paintLbl}}" [editable]="false" [width]="120"
                         [filterable]="false" [sortable]="false">
        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">

          <span *ngIf="dataItem?.jobName">
            {{dataItem.paintName}}
          </span>
          <span *ngIf="!dataItem?.jobName">
            <span *ngIf="dataItem.finishValue==='22'">
              <kendo-dropdownlist [data]="dataItem.paintValue"
                                  [value]="{value:dataItem.paint,name:dataItem.paintName}"
                                  [textField]="'name'"
                                  [valueField]="'value'"
                                  (valueChange)="handlePaintChange($event,dataItem)"
                                  [filterable]="true"
                                  (filterChange)="handlePaintFilter($event,dataItem)"
                                  (open)="handlePaintFilter(null,dataItem)"
                                  class="finishCls"
                                  [ngClass]="{'borderRed':dataItem?.isEmptyPaint}"></kendo-dropdownlist>
            </span>
          </span>
          
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column media="(min-width: 1050px)" field="availableFinishes" title="{{cartLblTxt.extrusionLbl?cartLblTxt.extrusionLbl:cart.extrusionLbl}}" [editable]="enableEdit" [width]="100"
                         [filterable]="false" [sortable]="false">
        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
          <span *ngIf="dataItem?.jobName">
            {{dataItem.size}}
          </span>
          <span *ngIf="!dataItem?.jobName">
            <kendo-dropdownlist [data]="dataItem.currentSizes" [textField]="'value'" [valueField]="'value'"
                                [value]="{value:dataItem.size}" (valueChange)="handleCartItemSizeChange($event,dataItem)"
                                *ngIf="dataItem?.itemType===1 && dataItem?.currentSizes?.length>0" class="extrusionDropCls"></kendo-dropdownlist>
            <span *ngIf="dataItem.itemType===1 && dataItem?.currentSizes?.length<1">
              {{dataItem?.size}}
            </span>
          </span> 
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column media="(min-width: 1050px)" [editable]="false" field="itemDescription" [minResizableWidth]="180" [width]="180"
                         title="{{cartLblTxt.descriptionLbl?cartLblTxt.descriptionLbl:cart.descriptionLbl}}" [footerStyle]="{'border-color': 'rgba(0,0,0,0)'}">
      </kendo-grid-column>
      <kendo-grid-column media="(min-width: 1050px)" [editable]="false" field="basePrice" [minResizableWidth]="70" [width]="100" title="{{cartLblTxt.listPriceLbl?cartLblTxt.listPriceLbl:cart.listPriceLbl}}"
                         [footerStyle]="{'border-color': 'rgba(0,0,0,0)'}">
        <ng-template kendoGridCellTemplate let-dataItem>
          {{dataItem.listPrice | currency: dataItem.currencySymbol}}
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column media="(min-width: 1050px)" [editable]="false" field="cmp" [minResizableWidth]="70" [width]="70" title="{{cartLblTxt.multiplierLbl?cartLblTxt.multiplierLbl:cart.multiplierLbl}}"
                         [footerStyle]="{'border-color': 'rgba(0,0,0,0)'}">
        <ng-template kendoGridCellTemplate let-dataItem>
          <span>
            {{dataItem?.cmp | number:'1.3-3'}}
          </span>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column media="(min-width: 1050px)" [editable]="false" field="unitPrice" [minResizableWidth]="70" [width]="80" title="{{cartLblTxt.unitPriceLbl?cartLblTxt.unitPriceLbl:cart.unitPriceLbl}}"
                         [footerStyle]="{'border-color': 'rgba(0,0,0,0)'}">
        <ng-template kendoGridCellTemplate let-dataItem>
          {{dataItem.unitPrice | currency: dataItem.currencySymbol}}
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column media="(min-width: 1050px)" [editable]="false" field="extendedPrice" [minResizableWidth]="70" [width]="150"
                         title="{{cartLblTxt.extendedPriceLbl?cartLblTxt.extendedPriceLbl:cart.extendedPriceLbl}}">
        <ng-template kendoGridCellTemplate let-dataItem>
          {{dataItem.extendedPrice | currency: dataItem.currencySymbol}}
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column media="(min-width: 1050px)" [editable]="false" field="jobName" [minResizableWidth]="100" [width]="110" title="{{cartLblTxt.quoteNameLbl?cartLblTxt.quoteNameLbl:cart.quoteNameLbl}}"
                         [footerStyle]="{'border-color': 'rgba(0,0,0,0)'}">
        <ng-template kendoGridCellTemplate let-dataItem>
          {{dataItem.jobName}}
        </ng-template>
        <ng-template kendoGridFooterTemplate>
          <div class="minfee-footer">
            <div class="cartTotalInGrid">
              {{cartItemsTotal | currency}} - {{cartLblTxt.totalPriceLbl?cartLblTxt.totalPriceLbl:cart.totalPriceLbl}}
            </div>

            <div *ngIf="showMinOrderFee" class="minfee-line">
              {{ minFeeDisplayLine }}
            </div>
            <div class="discount-line" *ngIf="gridData.length > 0">
              <div>
                {{cartLblTxt.cartDiscountLbl?cartLblTxt.cartDiscountLbl:cart.cartDiscountLbl}}
                {{cartDiscount}}%
              </div>
            </div>
          </div>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-command-column media="(min-width: 1050px)" [resizable]="false" [width]="80"
                                 [headerStyle]="{'background-color': '#d3d3d3', 'border-color': 'rgba(0,0,0,0)'}"
                                 [footerStyle]="{'border-color': 'rgba(0,0,0,0)'}">
        <ng-template kendoGridCellTemplate class="d-super-center" let-dataItem>
          <button class="k-button k-grid-remove-command " (click)="removeConfirmation(dataItem);selectedGridRow(dataItem) ">
            <span class="k-icon k-i-trash">
            </span>
          </button>
        </ng-template>
      </kendo-grid-command-column>
      <ng-template kendoPagerTemplate let-totalPages="totalPages" let-currentPage="currentPage">
        <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
        <kendo-pager-numeric-buttons [buttonCount]="5"></kendo-pager-numeric-buttons>
        <kendo-pager-info></kendo-pager-info>
        <kendo-pager-next-buttons></kendo-pager-next-buttons>
        <kendo-pager-page-sizes [pageSizes]="[50,75,100]"></kendo-pager-page-sizes>
      </ng-template>

    </kendo-grid>
  </div>
</form>
<!-- END CART GRID -->
<!-- START CART BUTTONS -->
<div class="d-super-center flex-xs-column flex-sm-column flex-md-row flex-lg-row flex-xl-row">
  <button (click)="importDialogOpen()" class=" m-3 btn k-button btn-lg" kendoButton [icon]="'file-bac'">
    <!--Import--> {{cartLblTxt.importLbl?cartLblTxt.importLbl:cart.importLbl}}
  </button>
  <button kendoButton [icon]="'plus'" class="m-3 btn btn-lg" (click)="addToQuote()" [disabled]="isEmptyPaintInGrid">
    <!--Add to Quote--> {{cartLblTxt.addToQuoteLbl?cartLblTxt.addToQuoteLbl:cart.addToQuoteLbl}}
  </button>
  <button kendoButton [icon]="'trash'" class="m-3 btn btn-lg" (click)="openConfirmRemoveAllDialog()">
    <!--Empty Cart--> {{cartLblTxt.emptyCartLbl?cartLblTxt.emptyCartLbl:cart.emptyCartLbl}}
  </button>
  <button kendoButton [icon]="'shopping-cart'" [routerLink]="['/cart/checkout']" (click)="proceedToCheckout()" [disabled]="isEmptyPaintInGrid"
          [hidden]="(totalCartItem$ | async)<1"
          class="m-3 clearKendoButton btn btn-success">
    <!--Proceed to Checkout--> {{cartLblTxt.ProceedToCheckoutLbl?cartLblTxt.ProceedToCheckoutLbl:cart.ProceedToCheckoutLbl}}
  </button>
</div>
<kendo-dialog title="{{cartLblTxt.confirmLbl?cartLblTxt.confirmLbl:cart.confirmLbl}}" *ngIf="gridItemToRemove" (close)="confirmRemove(false)">
  <p style="margin: 30px; text-align: center;">
    {{cartLblTxt.deleteConfirmLbl?cartLblTxt.deleteConfirmLbl:cart.deleteConfirmLbl}}
    <b>{{cartLblTxt.itemNumberLbl?cartLblTxt.itemNumberLbl:cart.itemNumberLbl}} : {{ gridItemToRemove.itemNumber }}</b>?
  </p>
  <kendo-dialog-actions>
    <button class='k-button' (click)="confirmRemove(false)">
      {{cartLblTxt.deleteNoLbl?cartLblTxt.deleteNoLbl:cart.deleteNoLbl}}
    </button>
    <button class='k-button k-primary' (click)="confirmRemove(true)" primary="true">
      {{cartLblTxt.deleteYesLbl?cartLblTxt.deleteYesLbl:cart.deleteYesLbl}}
    </button>
  </kendo-dialog-actions>
</kendo-dialog>
<kendo-dialog title="{{cartLblTxt.confirmLbl?cartLblTxt.confirmLbl:cart.confirmLbl}}" *ngIf="removeAllItemsConfirmationDialog" (close)="confirmRemoveAll(false)">
  <p style="margin: 30px; text-align: center;">
    {{cartLblTxt.confirmCartDelete?cartLblTxt.confirmCartDelete:cart.confirmCartDelete}}
  </p>
  <kendo-dialog-actions>
    <button class='k-button' (click)="confirmRemoveAll(false)">
      {{cartLblTxt.deleteNoLbl?cartLblTxt.deleteNoLbl:cart.deleteNoLbl}}

    </button>
    <button class='k-button k-primary' (click)="confirmRemoveAll(true)" primary="true">
      {{cartLblTxt.deleteYesLbl?cartLblTxt.deleteYesLbl:cart.deleteYesLbl}}
    </button>
  </kendo-dialog-actions>
</kendo-dialog>


<!-- This is for Item image-->
<kendo-dialog *ngIf="showImageBox" (close)="closeImageModal()">
  <div style="text-align: center;">
    <div>
      <div class="k-display-flex justify-content-between float-right">
        <span class="k-icon k-i-close" (click)="closeImageModal()"></span>
      </div>
      <div>
        <strong>{{this.selectedItem.itemDescription}}</strong>
      </div>
      <div class='contentInfobox'>
        <div class="details">
          <img class="infoBoxImgKKItem a" imageLoader src='../../../assets/images/loading.svg' *ngIf="!selectedItem?.thumbnail" alt="product img">
          <span *ngIf="selectedItem?.thumbnail" >
          <img class="infoBoxImgKKItem" imageLoader [src]='selectedItem?.thumbnail' *ngIf="selectedItem?.thumbnail" alt="product img">
          </span>
        </div>
      </div>
      <div class="d-flex justify-content-center" *ngIf="selectedItem.itemType===2">
        <button kendoButton [icon]="'copy'" (click)="navigateToCopyConfigProduct(selectedItem)" class="m-3 blackBtn" [disabled]="selectedItem?.jobName">
          {{cartLblTxt.copyLbl?cartLblTxt.copyLbl:cart.copyLbl}}
        </button>
        <button kendoButton [icon]="'edit'" (click)="navigateToEditConfigProduct(selectedItem)" class="m-3 blackBtn" [disabled]="selectedItem?.jobName">
          {{cartLblTxt.editLbl?cartLblTxt.editLbl:cart.editLbl}}
        </button>
      </div>
    </div>
  </div>
</kendo-dialog>
<app-import-item *ngIf="importDialog.opened" (importCompleteEvent)="importCompleteEvent($event)" [inputData]="importDialog"></app-import-item>

<app-add-item-to-quote *ngIf="quoteDialog.isOpened" (addToQuoteCompleteEvent)="addToQuoteComplete($event)" [inputQuoteData]="quoteDialog"></app-add-item-to-quote>
